import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cost-accounts',
  templateUrl: './cost-accounts.component.html',
  styleUrls: ['./cost-accounts.component.css']
})
export class CostAccountsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/cost-accounts/cost-accounts.component.ts